<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
            thead-class="d-none"
        />
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        }
    },
    data: () => ({
        items: [],
    }),
    methods: {
        open(item) {

            this.items = [
                {
                    field: 'Material',
                    value: item.material.descricaoCompleta,
                },
                {
                    field: 'Quantidade',
                    value: item.quantidade,
                },
                {
                    field: 'Lote',
                    value: item.lote,
                },
                {
                    field: 'Validade do lote',
                    value: item.validadeLote,
                },
                {
                    field: 'Valor unitário',
                    value: item.valorUnitario,
                },
                {
                    field: 'Valor total',
                    value: item.valorTotal,
                },
                {
                    field: 'Número do empenho',
                    value: item.numeroEmpenho,
                },
                {
                    field: 'Despesas',
                    value: item.despesas,
                },
                {
                    field: 'Número da autorização de fornecimento',
                    value: item.numeroAutorizacaoFornecimento,
                },
                {
                    field: 'Código de barras',
                    value: item.codigoBarras,
                },
                {
                    field: 'Fabricante',
                    value: item.fabricante ? item.fabricante.nome : '',
                },
            ]

            this.$refs.Modal.show()
        },
    }
}
</script>